import {CodeBlock} from './CodeBlock';
import {createDefaultContent} from './utils';
import {DEFAULT_MODE} from './constants';

export default CodeBlock;

export {
  createDefaultContent as createCodeBlockContent,
  DEFAULT_MODE,
}
